import base64 from "base-64";
import { useMemo, useContext, useEffect, useState } from "react";
import { Dialog } from "@mui/material";

import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import EditIcon from "@mui/icons-material/Edit";
import CancelPresentationIcon from "@mui/icons-material/CancelPresentation";
import CircularProgress from "@mui/material/CircularProgress";
import Divider from "@mui/material/Divider";
import Alert from "@mui/material/Alert";
import moment from "moment";

import Filters from "../../libs/filters/Filters";

import { ContextApi } from "../../context/contextApi";

import { set, useForm } from "react-hook-form";
import { useNavigate } from "react-router-dom";

import { getCityFromUf, getUfsAll } from "../../services/apis/ibgeApi";
import { mockApiData } from "../../services/mockApi/mockApi";

import styles from "./style.module.scss";

export function DetailsCamera({
  setShowDetailCamera,
  showDetailCamera,
  dataCameras,
}) {
  const navigate = useNavigate();
  const {
    deleteCam,
    getRegions,
    deletarImagem,
    allEstadosOrdering,
    deleteVideos,
  } = useContext(ContextApi);
  const [confirmDelete, setConfirmDelete] = useState(false);
  const [showFormEditCamera, setShowFormEditCamera] = useState(false);
  const countries = useMemo(() => {
    if (allEstadosOrdering.length === 0) {
      return [];
    }
    let arrayCountries = [];
    allEstadosOrdering.forEach((element) => {
      arrayCountries.push({
        id: element.id,
        label: element.estado_sigla,
        description: element.nome,
      });
    });
    return arrayCountries;
  }, [allEstadosOrdering]);
  const [city, setCity] = useState(null);
  const [loadingEdit, setLoadingEdit] = useState(false);
  const [ufSelected, setUfSelected] = useState(dataCameras?.estado_sigla);
  const [ufSelect, setUfSelect] = useState("");
  const [selectedRegion, setSelectedRegion] = useState(null);
  const [imageRetDireita, setImageRetDireita] = useState({
    isImage: false,
    logoDireita: "",
  });
  const [imageRetEsquerda, setImageRetEsquerda] = useState({
    isImage: false,
    logoEsquerda: "",
  });
  const [imageRetFundo, setImageRetFundo] = useState({
    isImage: false,
    planoFundo: "",
  });
  const [imageRetPoster, setImageRetPoster] = useState({
    isImage: false,
    poster: "",
  });

  async function getCity() {
    let arrayCities = [];
    await getCityFromUf(ufSelect)
      .then((response) =>
        response.data.map((city) => {
          return arrayCities.push({
            id: city.id,
            description: city.nome,
          });
        })
      )
      .catch((err) => console.log(err));
    setCity(arrayCities);
  }

  function insertImageRet() {
    if (dataCameras.marca_dagua_superior_direito) {
      setImageRetDireita({
        isImage: true,
        logoDireita: dataCameras.marca_dagua_superior_direito,
      });
    } else if (dataCameras.marca_dagua_superior_direito === null) {
      setImageRetDireita({
        isImage: false,
        logoDireita: "",
      });
    }
    if (dataCameras.marca_dagua_superior_esquerdo) {
      setImageRetEsquerda({
        isImage: true,
        logoEsquerda: dataCameras.marca_dagua_superior_esquerdo,
      });
    } else if (dataCameras.marca_dagua_superior_esquerdo === null) {
      setImageRetEsquerda({
        isImage: false,
        logoEsquerda: "",
      });
    }
    if (dataCameras.logo) {
      setImageRetFundo({
        isImage: true,
        planoFundo: dataCameras.logo,
      });
    } else if (dataCameras.logo === null) {
      setImageRetFundo({
        isImage: false,
        planoFundo: "",
      });
    }
    if (dataCameras.poster) {
      setImageRetPoster({
        isImage: true,
        poster: dataCameras.poster,
      });
    } else if (dataCameras.poster === null) {
      setImageRetPoster({
        isImage: false,
        poster: "",
      });
    }
  }

  function handleCloseDetailCamera() {
    setShowDetailCamera(false);
    setShowFormEditCamera(false);
  }

  async function deleteItem(id) {
    await deleteCam(id);
    setConfirmDelete(false);
    handleCloseDetailCamera();
  }

  function LineDetails({ label, description }) {
    return (
      <>
        <div className={styles.boxOneInformation}>
          <span>{label}</span>
          <p>{description}</p>
        </div>
        <Divider className={styles.divider} />
      </>
    );
  }

  function handleSelectedUf() {
    if (countries) {
      let ufFilter = countries.filter((retUf) => retUf.id === Number(ufSelect));
      setUfSelected(ufFilter[0]?.label);
    }
  }

  useEffect(() => {
    getRegions();
  }, []);

  useEffect(() => {
    insertImageRet();
  }, [dataCameras]);

  useEffect(() => {
    handleSelectedUf();
    getCity();
  }, [ufSelect]);

  return (
    <Dialog
      onClose={handleCloseDetailCamera}
      open={showDetailCamera}
      className={styles.dialogModalContainer}
    >
      <div className={styles.headerModalDetails}>
        <div className={styles.boxIconClose}>
          <CancelPresentationIcon onClick={handleCloseDetailCamera} />
        </div>
        <span>Camera {dataCameras.nome_camera}</span>
        <div className={styles.boxBTNHeader}>
          {!confirmDelete && (
            <>
              <div
                className={
                  loadingEdit ? styles.BTNEditarLoading : styles.BTNEditar
                }
                onClick={() => {
                  setLoadingEdit(true);
                  setSelectedRegion({
                    idSelected: dataCameras.area_regiao.id,
                    regionSelected: dataCameras.area_regiao.nome,
                  });
                  setTimeout(() => {
                    navigate(`/editar-camera/${dataCameras.id}`);
                    setLoadingEdit(false);
                  }, 1500);
                }}
              >
                {!loadingEdit && (
                  <>
                    <p>Editar</p>
                    <EditIcon />
                  </>
                )}
                {loadingEdit && <CircularProgress size={20} />}
              </div>
              <div
                className={styles.BTNExcluir}
                onClick={() => setConfirmDelete(true)}
              >
                <p>Excluir</p>
                <DeleteForeverIcon />
              </div>
            </>
          )}
          {confirmDelete && (
            <Alert
              variant="filled"
              severity="error"
              className={styles.confirmDelete}
            >
              Deseja Excluir este item de forma permanente?
              <div
                className={styles.BTNExcluirConfirm}
                onClick={() => deleteItem(dataCameras.id)}
              >
                <p>Excluir</p>
                <DeleteForeverIcon />
              </div>
            </Alert>
          )}
        </div>
      </div>
      <div className={styles.containerModalDetails}>
        {!showFormEditCamera && (
          <>
            <LineDetails
              label="Id Stream"
              description={dataCameras.stream_id}
            />
            <LineDetails
              label="Nome da Camera"
              description={dataCameras.nome_camera}
            />
            <LineDetails
              label="Disponibilidade"
              description={
                dataCameras.disponibilidade ? dataCameras.disponibilidade : " "
              }
            />
            <div className={styles.boxTwoInformation}>
              <div>
                <span>Estado</span>
                <p>{dataCameras.estado}</p>
              </div>
              <div>
                <span>Cidade</span>
                <p>{dataCameras.cidade}</p>
              </div>
            </div>
            <Divider className={styles.divider} />
            <LineDetails
              label="Area"
              description={dataCameras.area_regiao.nome}
            />
            <LineDetails
              label="Nome do estabelecimento parceiro"
              description={dataCameras.parceiro}
            />
            <div className={styles.boxOneInformation}>
              <span>Link do estabelecimento parceiro</span>
              <br />
              <a href={dataCameras.parceiro_link} target="_blank">
                {dataCameras.parceiro_link}
              </a>
            </div>
            <Divider className={styles.divider} />
            <LineDetails
              label="previsão"
              description={dataCameras.previsao_metereologica}
            />
            <LineDetails
              label="Embed Monuv"
              description={
                dataCameras.embeded_monuv ? dataCameras.embeded_monuv : " "
              }
            />
            <LineDetails
              label="Posição(ordem) no menu"
              description={dataCameras.ordem ? dataCameras.ordem : " "}
            />
            <LineDetails
              label="Referências"
              description={
                dataCameras.referencia
                  ? Filters.removSpacesAndAccents(dataCameras.referencia)
                  : " "
              }
            />
            <LineDetails
              label="Descrição"
              description={dataCameras.descricao ? dataCameras.descricao : " "}
            />
            <LineDetails
              label="Visibilidade"
              description={dataCameras.visibilidade ? "Visível" : "Não visível"}
            />
            <LineDetails
              label="Add anúncio"
              description={dataCameras.ad_anuncio ? "Sim" : "Não"}
            />
            <LineDetails
              label="Mostrar anúncio apenas uma vez?"
              description={dataCameras.ad_anuncio_single ? "Sim" : "Não"}
            />
            <LineDetails
              label="Logo esquerda"
              description={
                dataCameras.marca_dagua_superior_esquerdo
                  ? dataCameras.marca_dagua_superior_esquerdo
                  : " "
              }
            />
            <LineDetails
              label="Logo direita"
              description={
                dataCameras.marca_dagua_superior_direito
                  ? dataCameras.marca_dagua_superior_direito
                  : " "
              }
            />
            <LineDetails
              label="Poster"
              description={dataCameras.poster ? dataCameras.poster : " "}
            />
            <LineDetails
              label="Plano de fundo"
              description={dataCameras.logo ? dataCameras.logo : " "}
            />
            <LineDetails
              label="Videos de anúncios"
              description={dataCameras.videos ? dataCameras.videos.length : " "}
            />
            <div className={styles.boxTwoInformation}>
              <div>
                <span>Data de Inclusão</span>
                <p>
                  {moment(dataCameras.created_at).format("DD/MM/YYYY - HH:mm")}
                </p>
              </div>
              {/* <div>
                        <span>Usuario</span>
                        <p>Fulano de Tal</p>
                    </div> */}
            </div>
          </>
        )}
      </div>
    </Dialog>
  );
}
